module.exports = __webpack_public_path__ + "static/media/percy.e041b0d4.PNG";